import { render, staticRenderFns } from "./JointsConfiguratorSelectorPopup.vue?vue&type=template&id=0f698b4e&scoped=true"
import script from "./JointsConfiguratorSelectorPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./JointsConfiguratorSelectorPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./JointsConfiguratorSelectorPopup.vue?vue&type=style&index=0&id=0f698b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f698b4e",
  null
  
)

export default component.exports